/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Formik} from 'formik'
import useUtils from './useUtils'
import {useLocation, useNavigate} from 'react-router-dom'
import {FaTimes} from 'react-icons/fa'
import {setTitle} from '../../redux/reducers/mainSlice'
import {useDispatch} from 'react-redux'
import AssignConfirmation from '../../modules/alert/AssignConfirmation'

const AddFAQ = () => {
  const {submitFAQ, modifyFAQ} = useUtils()
  const location = useLocation()
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const locationState = location?.state?.values || null
  dispatch(setTitle('FAQs'))
  const navigate = useNavigate()

  const initialValues = locationState
    ? {
        id: locationState?.id,
        isEdit: true,
        question: locationState?.question,
        answer: locationState?.answer,
      }
    : {
        question: locationState?.question,
        answer: locationState?.answer,
      }

  const validationSchema = Yup.object().shape({
    question: Yup.string().required('Please enter question'),
    answer: Yup.string().required('Please enter answer'),
  })

  const handleSubmit = (values) => {
    const data = {
      question: values.question,
      answer: values.answer,
    }
    if (values.isEdit) {
      modifyFAQ(values.id, data)
    } else {
      submitFAQ(values)
    }
  }

  return (
    <>
      <div className='card card-custom'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue}) => (
            <form className='form' onSubmit={handleSubmit}>
              <div className='card-body'>
                <div className='tab-content pt-3'>
                  <div className='row align-items-center flex-wrap'>
                    <div className='col-8'>
                      <label className='col-form-label required fw-bold fs-6'>Question</label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder='Question'
                        name='question'
                        value={values.question}
                        onChange={handleChange}
                      />
                      {touched.question && errors.question && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.question}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='row align-items-center flex-wrap mt-7'>
                    <div className='col-8'>
                      <label className='col-form-label required fw-bold fs-6'>Answer</label>
                      <textarea
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 '
                        style={{height: '150px', width: '100%'}}
                        placeholder='Answer'
                        name='answer'
                        value={values.answer}
                        onChange={handleChange}
                      />
                      {touched.answer && errors.answer && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert' className='text-danger'>
                            {errors.answer}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Submit Buttons */}
              <div className='d-flex align-items-center justify-content-end my-5'>
                <button
                  type='button'
                  className='btn btn-danger ms-2 mt-2 me-2'
                  onClick={() => navigate('/faqlist')}
                >
                  Cancel
                </button>
                <button
                  type='button'
                  onClick={() => {
                    if (values?.isEdit) {
                      setIsOpen(true) // Open the confirmation modal
                    } else {
                      document.querySelector('form')?.requestSubmit() // Directly submit in create mode
                    }
                  }}
                  className='btn btn-primary ms-2 mt-2 me-2'
                >
                  {!values.isEdit ? 'Submit' : 'Update'}
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
      <AssignConfirmation
        isVisible={isOpen}
        message='Are you sure you want to update this FAQ?'
        onConfirm={() => {
          setIsOpen(false)
          setTimeout(() => {
            document.querySelector('form')?.requestSubmit() // Triggers form submission
          }, 0)
        }}
        onCancel={() => setIsOpen(false)}
      />
    </>
  )
}

export default AddFAQ
